export const GET_HOME_BANNERS = "GET_HOME_BANNERS";
export const GET_HOME_SLIDERS = "GET_HOME_SLIDERS";
export const VIEW_STORIES = "VIEW_STORIES";
export const UPDATE_STORIES_VIEW = "UPDATE_STORIES_VIEW";
export const GET_SEARCHITEM = "GET_SEARCHITEM";

